import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import EditEmployeeForm from './EditEmployeeForm';
import ContentHeader from '../ContentHeader/ContentHeader';

const styles = theme => ({
  container: {
    minHeight: '100vh',
    height: 'auto',
    paddingTop: '5px',
    paddingBottom: '0px',
  },
  title: {
    fontWeight: theme.typography.fontWeightStrong,
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
  },
  registerButton: {
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  cardForm: {
    backgroundColor: theme.palette.primary.contrastText,
    padding: '1% 5%',
    borderColor: theme.palette.grey[300],
  },
  updateFileText: {
    marginBottom: '12px',
  },
  updateFile: {
    flex: '1',
  },
  updateFileButton: {
    backgroundColor: theme.palette.grey[700],
    color: theme.palette.primary.contrastText,
    padding: '8px 8%',
    borderRadius: '50px',
    fontWeight: 'bold',
    fontSize: '80%',
  },
});

const EditEmployee = ({
  classes, loading, title, subTitle, UpdateEmployee, departments, offices, data,keepData, dataToKeep
}) => (
  <Grid container>
    <Grid item xs container alignItems="flex-start" className={classes.container}>
      <Grid container alignContent="space-between">
        <ContentHeader title={`${title} Funcionário`} subtitle={subTitle} />

        <Paper elevation={2} className={classes.cardForm} >
          <EditEmployeeForm
            title={title}
            data={data}
            onUpdateEmployee={UpdateEmployee}
            departments={departments}
            offices={offices}
            loading={loading}
            keepData={keepData}
            dataToKeep={dataToKeep}
          />
        </Paper>
      </Grid>
    </Grid>
  </Grid>
);

export default withStyles(styles)(EditEmployee);
